import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { formatCase } from "../../libs/utils";
import UserInfoModal from "./UserInfoModal";
const unFormated = ['SSN'];
const valueWithSuffix = [
  {
    id: 'contributionPercentage',
    suffix: '%'
  }
];

let columns = [
  {
    dataField: "id",
    text: "Id",
    headerClasses: "text-break",
    hidden: true,
  },
  {
    dataField: "email",
    text: "Email",
    headerClasses: "text-break",
  },
  {
    dataField: "displayName",
    text: "Event Name",
  },
  {
    dataField: "userCreateTime",
    text: "User Create Time",
    formatter: (cell) => {
      if (!cell) {
        return <></>;
      }
      return cell;
    },
  },
  {
    dataField: "lastUpdateTime",
    text: "Last Update Time",
    formatter: (cell) => {
      if (!cell) {
        return <></>;
      }
      return cell;
    },
  },
  {
    dataField: "company",
    text: "Company",
  },
  {
    dataField: "state",
    text: "State",
  },
  {
    dataField: "country",
    text: "Country",
  },
  {
    dataField: "info",
    text: "Details",
    formatter: (cell) => {
      if (!cell) {
        return <></>;
      }
      let meta = [];
      for (let key in cell) {
        let cellWithSuffix = valueWithSuffix.find(element => element.id === key);
        meta.push({
          name: unFormated.find(element => element === key) ? key : formatCase(key),
          value: cellWithSuffix ? `${cell[key]}${cellWithSuffix.suffix}`
            : key === 'paystub-uploaded' ?
              `ReactDOM.render(
              ${cell[key]},
              document.getElementById("root")
            );` :
              cell[key]
        });
      }
      return <UserInfoModal info={meta} />;
    },
  },
];

const Events = ({ events }) => {
  return (
    <div>
      <BootstrapTable
        bootstrap4={true}
        id="id"
        wrapperClasses="table-fixed-height"
        classes="table-taabl table-document"
        keyField="id"
        bordered={false}
        data={events}
        noDataIndication={() => <div>No data found</div>}
        columns={columns}
      />
    </div>
  );
};

export default Events;
